import zh_TW from '../../date-picker/locale/zh_TW';
export default zh_TW;



// WEBPACK FOOTER //
// ./components/calendar/locale/zh_TW.tsx